import registerIntros from '../Components/Navigation/Help/persistIntroState.js';
import registerHints from '../Components/Navigation/Help/persistHintState.js';

// register
registerIntros();
registerHints();
export const ServicesInit = () => '';
